import moment from 'moment';

const formatTimeFromDate = (dateString) => {
  const date = moment(dateString);
  const formattedTime = date.format('HH:mm');
  return formattedTime;
};

export default formatTimeFromDate;
